import { Button, ButtonProps, Typography, theme } from "antd";
import { CSSProperties, ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

export const isInternalPath = (path: string) =>
  path.startsWith("/") && !path.startsWith("//");

export type InternalLinkProps = {
  to: string;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
};

export const InternalLink = ({
  to,
  children,
  className,
  style,
  onClick,
}: InternalLinkProps) => {
  if (!isInternalPath(to)) {
    return (
      <a href={to} className={className} style={style} onClick={onClick}>
        {children}
      </a>
    );
  }

  return (
    <RouterLink to={to} className={className} style={style} onClick={onClick}>
      {children}
    </RouterLink>
  );
};

/** Link-styled text with client-side routing for in-app paths. */
export const InternalTypographyLink = ({
  to,
  children,
  style,
  onClick,
}: InternalLinkProps) => {
  const { token } = theme.useToken();
  const linkStyle: CSSProperties = {
    color: token.colorLink,
    ...style,
  };

  if (!isInternalPath(to)) {
    return (
      <Typography.Link href={to} style={style} onClick={onClick}>
        {children}
      </Typography.Link>
    );
  }

  return (
    <RouterLink to={to} style={linkStyle} onClick={onClick}>
      {children}
    </RouterLink>
  );
};

export type NavButtonProps = ButtonProps & {
  to: string;
};

/** Primary/ghost buttons that navigate in-app without a full page reload. */
export const NavButton = ({ to, children, ...buttonProps }: NavButtonProps) => (
  <InternalLink to={to} style={{ display: "block", width: "100%" }}>
    <Button {...buttonProps}>{children}</Button>
  </InternalLink>
);
